import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "plan-content" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-body d-flex flex-column gap-4 sm-fs-xxs" }, [
  /*#__PURE__*/_createElementVNode("p", null, " By digitally signing, the undersigned hereby certifies that: "),
  /*#__PURE__*/_createElementVNode("p", null, " I wish to enroll in the Plan C Medical Reimbursement Program (MRP) as a stand-alone option, as described in the Plan C Summary Plan Description booklet. "),
  /*#__PURE__*/_createElementVNode("p", null, " To be eligible for the Plan C-MRP as a stand-alone option, I understand that I, and any dependents I enroll, must be covered by a group health plan (i.e. employer or union sponsored) that provides minimum value as defined in the Patient Protection and Affordable Care Act (ACA). "),
  /*#__PURE__*/_createElementVNode("p", null, " Accordingly, to enroll in this option and waive enrollment in Plan C1, C2, C3 or C4, I must click the box and submit proof of other group health coverage (copy of front and back of coverage ID card along with a statement from the insurer or plan sponsor if my ID card does not specify that it is group coverage). "),
  /*#__PURE__*/_createElementVNode("p", null, " By clicking the box, I hereby certify that my and my enrolled dependents’ (if any) other medical coverage is through an employer or union sponsored group health plan that provides minimum value under the ACA. In addition, I understand that recertification and proof of other group health coverage (employer or union sponsored) must be submitted annually at the Plan’s Open Enrollment period. "),
  /*#__PURE__*/_createElementVNode("p", null, " I also agree to inform the Fund immediately if I (or my dependents) lose such other coverage. ")
], -1)
const _hoisted_4 = { class: "d-flex align-items-end justify-content-between gap-2" }
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckBox = _resolveComponent("CheckBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_CheckBox, {
          label: "By checking this box, you are certifying that you have read, understood and agree to the conditions listed herein.",
          className: "alert-checkbox text-large",
          modelValue: $setup.termsAccepted,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.termsAccepted) = $event)),
          id: "mrp-agree"
        }, null, 8, ["modelValue"]),
        _createElementVNode("button", {
          disabled: !$setup.termsAccepted,
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => ($setup.proceed && $setup.proceed(...args)), ["prevent"])),
          class: "btn btn-primary"
        }, "Proceed", 8, _hoisted_5)
      ])
    ])
  ]))
}